import _ from 'lodash'
import apis from '@/apis'
import Constants from '@/constants'

// URL and endpoint constants
const PATH_PREFIX = 'adapt/'
const PATH_INSTAGRAM_TAGPAGE = 'api/instagram/tagpage/'
const PATH_INSTAGRAM_USERPAGE = 'api/instagram/userpage/'

export default {
  instagramUser (token, maxid) {
    var maxidString = (maxid ? ('/' + maxid) : '')
    return apis.get(`${Constants.BASE_API}${PATH_INSTAGRAM_USERPAGE}${token}${maxidString}`)
  },

  instagramTag (tag, maxid) {
    var maxidString = (maxid ? ('/' + maxid) : '')
    return apis.get(`${Constants.BASE_API}${PATH_INSTAGRAM_TAGPAGE}${tag}/24${maxidString}`)
  },

  // info = info
  infos () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}info/all`)
  },

  async infoNamed (name) {
    let data = await apis.get(`${Constants.BASE_API}${PATH_PREFIX}info/name/${name}`)
    return data
  },

  async infoNamedLike (name) {
    let data = await apis.get(`${Constants.BASE_API}${PATH_PREFIX}info/name-like/${name}`)
    if (data) {
      data = _.map(data, (item, index) => {
        try {
          if (item.meta && item.meta.length > 0) {
            item.meta = JSON.parse(item.meta)
          }
        } catch (error) {
          console.error(`error parse json at index ${index}`, error)
        }
        return item
      })
    }
    return data
  },

  // sponsor = awards
  sponsors () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}sponsor/all`)
  },

  // hotlinks
  hotlinks () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}hotlink/all`)
  },

  hotlinkNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}hotlink/name/${name}`)
  },

  // service
  services () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}service/all`)
  },

  async serviceNamed (name) {
    let data = await apis.get(`${Constants.BASE_API}${PATH_PREFIX}service/name/${name}`)
    if (data) {
      data = _.map(data, (item, index) => {
        try {
          if (item.meta && item.meta.length > 0) {
            item.meta = JSON.parse(item.meta)
          }
        } catch (error) {
          console.error(`error parse json at index ${index}`, error)
        }
        return item
      })
    }
    return data
  },

  // about = pages
  abouts () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}about/all`)
  },

  aboutNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}about/name/${name}`)
  },

  // staffs
  staffs () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}staff/all`)
  },

  // links
  links () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}link/all`)
  },

  linkNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}link/name/${name}`)
  },

  // links
  references () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}reference/all`)
  },

  referenceNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}reference/name/${name}`)
  },

  // faq = testimonials
  faqs () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}faq/all`)
  },

  faqNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}faq/name/${name}`)
  },

  // faq = testimonials
  testimonials () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}testimonial/all`)
  },

  testimonialNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}testimonial/name/${name}`)
  },

  // carousel () {
  //   return apis.get(`${Constants.BASE_API}carousel`)
  // },
  //
  // company () {
  //   return apis.get(`${Constants.BASE_API}company`)
  // },
  //
  // gallery () {
  //   return apis.get(`${Constants.BASE_API}gallery`)
  // },

  // events = opportunity placements
  events () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}event/all`)
  },

  eventWithId (id) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}event/id/${id}`)
  },

  // eventDetail (showId) {
  //   return apis.get(`${Constants.BASE_API}event/show/${showId}`)
  // },
  //
  // eventPrevious () {
  //   return apis.get(`${Constants.BASE_API}event/previous`)
  // },
  //
  // eventUpcoming () {
  //   return apis.get(`${Constants.BASE_API}event/upcoming`)
  // },

  email (form = {}) {
    let params = {
      ...form
    }
    return apis.post(`${Constants.BASE_API}${PATH_PREFIX}email/send`, params)
  },

  emailSubmit (form = {}) {
    let params = {
      ...form
    }
    return apis.post(`${Constants.BASE_API}${PATH_PREFIX}email/submit`, params)
  },

  signup (form = {}) {
    let params = {
      ...form
    }
    return apis.post(`${Constants.BASE_API}${PATH_PREFIX}signup/judge`, params)
  },

  subscribe (name, email) {
    return apis.post(`${Constants.BASE_API}${PATH_PREFIX}email/subscribe`, { name: name, email: email })
  },

  getRecaptcha () {
    return apis.get(`${Constants.BASE_API_BARE}${PATH_PREFIX}captcha.php`)
  },

  youtube (path, params) {
    return apis.get(`https://www.googleapis.com/youtube/v3/${path}`, params)
  }
}
